import React, { useEffect } from "react";
import moment from "moment";

import {
  InputNumber,
  Form,
  Icon,
  DatePicker,
  TimePicker,
  Button,
  Checkbox,
  Input
} from "antd";

const { Item } = Form;

const timeFormat = "HH:mm";
const dateFormat = "DD.MM.YYYY";

const OfferPaymentType = props => {
  const { form, disabled, sumUndestributedPrice } = props;

  const selectPayType = key => {
    const obj = {};
    const keys = props.form.getFieldValue(key.replace("Checked", ""));
    const keyChecked = !!props.form.getFieldValue(key);
    let nextKeys;
    obj[key] = !keyChecked;
    if (!keyChecked) {
      if (!keys || (keys && keys.length === 0)) {
        nextKeys = [0];
      } else {
        nextKeys = keys;
      }
    } else {
      nextKeys = [];
    }

    if (keyChecked) {
      if (key.replace("Checked", "") === "pay") {
        obj[key.replace("Checked", "Price")] = null;
      } else {
        keys.forEach(item => {
          obj[key.replace("Checked", "Price") + item] = null;
        });
      }
    }
    obj[key.replace("Checked", "")] = nextKeys;
    props.form.setFieldsValue(obj);
  };

  useEffect(() => {
    if (!getFieldValue("predPay") || getFieldValue("predPay").length < 1) {
      selectPayType("predPayChecked");
    }
    if (!getFieldValue("pay") || getFieldValue("pay").length < 1) {
      selectPayType("payChecked");
    }
    if (!getFieldValue("postPay") || getFieldValue("postPay").length < 1) {
      selectPayType("postPayChecked");
    }
  }, [disabled]);

  const addPayment = key => {
    const keys = props.form.getFieldValue(key);
    let nextKeys,
      obj = {};
    if (!keys || (keys && keys.length === 0)) {
      nextKeys = [0];
    } else {
      nextKeys = keys.concat([keys.length]);
    }
    obj[key] = nextKeys;

    props.form.setFieldsValue(obj);
  };

  const { getFieldDecorator, getFieldValue } = form;
  const arrivalDatetime = getFieldValue("arrivalDatetime");
  return (
    <>
      <div className="offer-card__sub-item">
        <div className="offer-card__item" hidden={disabled}>
          <span className="label">Выберите способ оплаты</span>
          <div className="pay-type-btns">
            {getFieldDecorator("predPayChecked", {
              valuePropName: "checked"
            })(<Checkbox style={{ display: "none" }} />)}
            {getFieldDecorator("payChecked", {
              valuePropName: "checked"
            })(<Checkbox style={{ display: "none" }} />)}
            {getFieldDecorator("postPayChecked", {
              valuePropName: "checked"
            })(<Checkbox style={{ display: "none" }} />)}

            {getFieldDecorator("predPay")(<Input type="hidden" />)}
            {getFieldDecorator("pay")(<Input type="hidden" />)}
            {getFieldDecorator("postPay")(<Input type="hidden" />)}

            <Button
              type="primary"
              ghost={!getFieldValue("predPayChecked")}
              onClick={() => selectPayType("predPayChecked")}
            >
              Предоплата
            </Button>
            <Button
              type="primary"
              ghost={!getFieldValue("payChecked")}
              onClick={() => selectPayType("payChecked")}
            >
              При посадке
            </Button>
            <Button
              type="primary"
              ghost={!getFieldValue("postPayChecked")}
              onClick={() => selectPayType("postPayChecked")}
            >
              Постоплата
            </Button>
          </div>
        </div>

        {!!getFieldValue("predPayChecked") &&
          Array.isArray(getFieldValue("predPay")) &&
          getFieldValue("predPay").map((item, index) => (
            <div
              className="offer-card__item"
              key={"predPay" + index}
              id={"predPay" + index}
            >
              <div>
                <span className="label">
                  <span>Предоплата, руб:</span>
                </span>
                <Item>
                  {getFieldDecorator("predPayPrice" + index)(
                    <InputNumber
                      style={{ width: 224 }}
                      placeholder="Укажите предоплату"
                      disabled={disabled}
                    />
                  )}
                </Item>
                <Item>
                  {getFieldDecorator("predPaymentTime" + index)(
                    <DatePicker
                      style={{ width: 128 }}
                      format={dateFormat}
                      placeholder="Укажите дату"
                      disabled={disabled}
                      disabledDate={currentDate =>
                        currentDate > moment(arrivalDatetime)
                      }
                    />
                  )}
                </Item>
                <Item>
                  {getFieldDecorator("predPaymentTime" + index)(
                    <TimePicker
                      style={{ width: 128 }}
                      defaultOpenValue={moment("00:00", "HH:mm")}
                      placeholder="Время"
                      format={timeFormat}
                      disabled={disabled}
                    />
                  )}
                </Item>

                {(!disabled &&
                  index === 0 &&
                  getFieldValue("predPay").length < 1) ||
                (!disabled && getFieldValue("predPay").length - 1 === index) ? (
                  <div className="extra-label additional-input">
                    <span className="add-pays">
                      <Icon
                        type="plus-circle"
                        onClick={() => addPayment("predPay")}
                      />
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        {(!!getFieldValue("payChecked") && (
          <div className="offer-card__item">
            <div>
              <span className="label">
                <span>При посадке, руб:</span>
              </span>
              <Item extra={"Наличными водителю"}>
                {getFieldDecorator("payPrice")(
                  <InputNumber
                    style={{ width: 224 }}
                    placeholder="Укажите оплату"
                    disabled={disabled}
                  />
                )}
              </Item>
              <Item>
                <DatePicker
                  style={{ width: 128 }}
                  format={dateFormat}
                  value={getFieldValue("arrivalDatetime")}
                  placeholder="Укажите дату"
                  disabled={true}
                />
              </Item>
            </div>
          </div>
        )) ||
          null}
        {(!!getFieldValue("postPayChecked") &&
          Array.isArray(getFieldValue("postPay")) &&
          getFieldValue("postPay").map((item, index) => (
            <div
              className="offer-card__item"
              key={"postPay" + index}
              id={"postPay" + index}
            >
              <div>
                <span className="label">
                  <span>Постоплата, руб:</span>
                </span>
                <Item>
                  {getFieldDecorator("postPayPrice" + index)(
                    <InputNumber
                      style={{ width: 224 }}
                      placeholder="Укажите оплату"
                      disabled={disabled}
                    />
                  )}
                </Item>
                <Item>
                  {getFieldDecorator("postPaymentTime" + index)(
                    <DatePicker
                      style={{ width: 128 }}
                      format={dateFormat}
                      placeholder="Укажите дату"
                      disabled={disabled}
                    />
                  )}
                </Item>
                <Item>
                  {getFieldDecorator("postPaymentTime" + index)(
                    <TimePicker
                      style={{ width: 128 }}
                      defaultOpenValue={moment("00:00", "HH:mm")}
                      placeholder="Время"
                      format={timeFormat}
                      disabled={disabled}
                    />
                  )}
                </Item>
                {(!disabled &&
                  index === 0 &&
                  getFieldValue("postPay").length < 1) ||
                (!disabled && getFieldValue("postPay").length - 1 === index) ? (
                  <div className="extra-label additional-input">
                    <span className="add-pays">
                      <Icon
                        type="plus-circle"
                        onClick={() => addPayment("postPay")}
                      />
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          ))) ||
          null}
        {!disabled && (
          <div
            className="order-create__item"
            style={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <span className="label">
              <span>Нераспределенная сумма,&nbsp;руб:</span>
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: sumUndestributedPrice === 0 ? "#323232" : "#F5222D"
              }}
            >
              <span
                style={{
                  fontSize: 20,
                  lineHeight: "24px",
                  letterSpacing: "-1px"
                }}
              >
                {sumUndestributedPrice
                  ? sumUndestributedPrice + " ₽"
                  : "0" + " ₽"}
              </span>
              <span
                style={{
                  fontSize: 12,
                  lineHeight: "14px",
                  letterSpacing: "-0.6px",
                  marginLeft: "16px",
                  color: sumUndestributedPrice === 0 ? "#9B9B9B" : "#F5222D"
                }}
              >
                Значение нераспределенной суммы должно быть равно нулю
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferPaymentType;
